export const getWidthRation = (width: number) => {
    return `${((width / 1440) * 100).toString()}%`;
};
